// export function nextSteps (left, right) {
//     const currentDate = new Date();
//     let nextStepDate = new Date();
//     let message = "";
//     if(
//         left === "Hazy image (due to cataract or significant corneal opacity)" ||
//         right === "Hazy image (due to cataract or significant corneal opacity)"||
//         left === "Severe Diabetic Retinopathy" ||
//         right === "Severe Diabetic Retinopathy" ||
//         left === "Proliferative Diabetic Retinopathy" ||
//         right === "Proliferative Diabetic Retinopathy"
//     ) {
//         nextStepDate.setMonth(currentDate.getMonth() + 3);
//         message = "Referral required immediately  and ask for a follow up visit after 3 Months";
//     }
//     else if (left === "Moderate Diabetic Retinopathy" || right === "Moderate Diabetic Retinopathy") {
//         nextStepDate.setMonth(currentDate.getMonth() + 6);
//         message = "Referral required within 3-6 Months and ask for a follow up visit after 6 Months";
//     }
//     else if (
//         left === "No Diabetic Retinopathy" ||
//         right === "No Diabetic Retinopathy" ||
//         left === "Mild Diabetic Retinopathy" ||
//         right === "Mild Diabetic Retinopathy"
//     ) {
//         nextStepDate.setFullYear(currentDate.getFullYear() + 1);
//         message = "Referral not required and ask for a follow up visit after a year";
//     }

//     const formattedDate = nextStepDate.toDateString().split(' ').slice(1).join(' ');

//     return { date: formattedDate, message };
// };

export function nextSteps(left, right, leftDME = null, rightDME = null, operatorOverride = { left: { fundus: false, eye: false }, right: { fundus: false, eye: false } }) {
  const currentDate = new Date();
  let nextStepDate = new Date();
  let message = "";

  // DR + DME Priority mapping (ordered from most severe to least severe)
  const DR_PRIORITY = {
      "Proliferative Diabetic Retinopathy (PDR) with DME": { 
        days: 3, 
        message: "Findings are suggestive of proliferative diabetic retinopathy with diabetic macular edema, indicating a high risk of vision loss. An urgent consultation with a retina specialist or ophthalmologist is strongly recommended within 3 days for immediate evaluation and management." 
      },
      "Proliferative Diabetic Retinopathy (PDR)": { 
        days: 3, 
        message: "Findings are suggestive of proliferative diabetic retinopathy, which may threaten vision. An urgent consultation with a retina specialist or ophthalmologist is recommended within 3 days to prevent further complications and potential vision loss." 
      },
      "Severe Non-Proliferative Diabetic Retinopathy (NPDR) with DME": { 
        days: 28, 
        message: "Findings are suggestive of severe non-proliferative diabetic retinopathy with diabetic macular edema. A consultation with an eye specialist is strongly recommended within 4 weeks for prompt evaluation and appropriate treatment." 
      },
      "Severe Non-Proliferative Diabetic Retinopathy (NPDR)": { 
        days: 28, 
        message: "Findings are suggestive of severe non-proliferative diabetic retinopathy. A consultation with an eye specialist is recommended within 4 weeks to ensure timely evaluation and reduce the risk of vision loss." 
      },
      "Moderate Non-Proliferative Diabetic Retinopathy (NPDR) with DME": { 
        days: 28, 
        message: "Findings are suggestive of moderate non-proliferative diabetic retinopathy with diabetic macular edema. A consultation with an eye specialist is recommended within 4 weeks for timely evaluation and management." 
      },
      "Moderate Non-Proliferative Diabetic Retinopathy (NPDR)": { 
        months: 3, 
        message: "Findings are suggestive of moderate non-proliferative diabetic retinopathy. A consultation with an eye specialist is recommended within 3 to 6 months for further evaluation and appropriate management." 
      },
      "Mild Non-Proliferative Diabetic Retinopathy (NPDR) with DME": { 
        days: 28, 
        message: "Findings are suggestive of mild non-proliferative diabetic retinopathy with diabetic macular edema. A consultation with an eye specialist is recommended within 4 weeks for further evaluation and appropriate management." 
      },
      "Mild Non-Proliferative Diabetic Retinopathy (NPDR)": { 
        months: 12, 
        message: "Early signs suggestive of mild non-proliferative diabetic retinopathy were detected. A specialist referral is not immediately required; however, a precautionary follow-up eye examination is recommended within 1 year." 
      },
      "No Diabetic Retinopathy": { 
        months: 12, 
        message: "No signs suggestive of diabetic retinopathy were detected. Referral to an eye specialist is not required at this time. Routine annual eye screening is recommended." 
      },
      "Non Gradable Image": { 
        days: 90, 
        message: "Referral required immediately due to poor image quality. Follow-up in 3 months." 
      }
  };

  // Helper function to normalize DR diagnosis names
  const normalizeDRName = (drName) => {
    if (!drName) return null;
    // Map various formats to standard names
    const mapping = {
      "No Diabetic Retinopathy": "No Diabetic Retinopathy",
      "No DR": "No Diabetic Retinopathy",
      "Mild Diabetic Retinopathy": "Mild Non-Proliferative Diabetic Retinopathy (NPDR)",
      "Mild NPDR": "Mild Non-Proliferative Diabetic Retinopathy (NPDR)",
      "Moderate Diabetic Retinopathy": "Moderate Non-Proliferative Diabetic Retinopathy (NPDR)",
      "Moderate NPDR": "Moderate Non-Proliferative Diabetic Retinopathy (NPDR)",
      "Severe Diabetic Retinopathy": "Severe Non-Proliferative Diabetic Retinopathy (NPDR)",
      "Severe NPDR": "Severe Non-Proliferative Diabetic Retinopathy (NPDR)",
      "Proliferative Diabetic Retinopathy": "Proliferative Diabetic Retinopathy (PDR)",
      "PDR": "Proliferative Diabetic Retinopathy (PDR)"
    };
    return mapping[drName] || drName;
  };

  // Helper function to check if DME is present
  const hasDME = (dmeGrade) => {
    return dmeGrade === "DME" || dmeGrade === "dme";
  };

  // Helper function to check if DR is severe or proliferative
  const isSevereOrProliferative = (drName) => {
    const normalized = normalizeDRName(drName);
    return normalized === "Severe Non-Proliferative Diabetic Retinopathy (NPDR)" || 
           normalized === "Proliferative Diabetic Retinopathy (PDR)";
  };

  // Helper function to create diagnosis key with DME
  const createDiagnosisKey = (drName, hasDMEStatus) => {
    const normalizedDR = normalizeDRName(drName);
    if (!normalizedDR) return null;
    
    if (hasDMEStatus) {
      // Add " with DME" to the diagnosis
      if (normalizedDR === "No Diabetic Retinopathy") {
        // No DR doesn't have a "with DME" variant
        return normalizedDR;
      }
      return `${normalizedDR} with DME`;
    }
    return normalizedDR;
  };

  // Check for operator override (fundus) conditions
  const hasLeftFundusOverride = operatorOverride?.left?.fundus || false;
  const hasRightFundusOverride = operatorOverride?.right?.fundus || false;

  // Condition 1: If BOTH eyes have override due to fundus → show user override message
  if (hasLeftFundusOverride && hasRightFundusOverride) {
    message = "The uploaded image. Image quality for Both eyes does not meet screening requirements; however, the user chose to proceed with the screening. As a result, AI-based assessment for diabetic retinopathy and/or diabetic macular edema could not be reliably performed.\nA consultation with an eye specialist is recommended.";
    // Format date (not really used but keeping for consistency)
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[nextStepDate.getMonth()];
    const day = nextStepDate.getDate();
    const year = nextStepDate.getFullYear();
    const formattedDate = `${month} ${day} ${year}`;
    return { date: formattedDate, message };
  }

  // Condition 2 & 3: Handle cases where one eye has fundus override
  if (hasLeftFundusOverride || hasRightFundusOverride) {
    // Get the eye that doesn't have override
    const nonOverrideEye = hasLeftFundusOverride ? right : left;
    const nonOverrideDME = hasLeftFundusOverride ? rightDME : leftDME;
    const nonOverrideHasDME = hasDME(nonOverrideDME);
    
    // Condition 2: If other eye has severe or proliferative → show that condition
    if (isSevereOrProliferative(nonOverrideEye)) {
      const diagnosisKey = createDiagnosisKey(nonOverrideEye, nonOverrideHasDME);
      if (diagnosisKey && DR_PRIORITY[diagnosisKey]) {
        const priority = DR_PRIORITY[diagnosisKey];
        if (priority.days) {
          nextStepDate.setDate(currentDate.getDate() + priority.days);
        } else if (priority.months) {
          nextStepDate.setMonth(currentDate.getMonth() + priority.months);
        }
        message = priority.message;
      } else {
        // Fallback: show user override message
        const eyeLabel = hasLeftFundusOverride ? "Left" : "Right";
        message = `The uploaded image. Image quality for ${eyeLabel} eye does not meet screening requirements; however, the user chose to proceed with the screening. As a result, AI-based assessment for diabetic retinopathy and/or diabetic macular edema could not be reliably performed.\nA consultation with an eye specialist is recommended.`;
      }
    }
    // Condition 3: If other eye has any DR + DME → show that DR + DME condition
    else if (nonOverrideEye && nonOverrideHasDME) {
      const diagnosisKey = createDiagnosisKey(nonOverrideEye, true);
      if (diagnosisKey && DR_PRIORITY[diagnosisKey]) {
        const priority = DR_PRIORITY[diagnosisKey];
        if (priority.days) {
          nextStepDate.setDate(currentDate.getDate() + priority.days);
        } else if (priority.months) {
          nextStepDate.setMonth(currentDate.getMonth() + priority.months);
        }
        message = priority.message;
      } else {
        // Fallback: show user override message
        const eyeLabel = hasLeftFundusOverride ? "Right" : "Left";
        message = `The uploaded image. Image quality for ${eyeLabel} eye does not meet screening requirements; however, the user chose to proceed with the screening. As a result, AI-based assessment for diabetic retinopathy and/or diabetic macular edema could not be reliably performed.\nA consultation with an eye specialist is recommended.`;
      }
    }
    // If other eye doesn't have severe/proliferative or DR+DME, show user override message
    else {
      const eyeLabel = hasLeftFundusOverride ? "Left" : "Right";
      message = `The uploaded image. Image quality for ${eyeLabel} eye does not meet screening requirements; however, the user chose to proceed with the screening. As a result, AI-based assessment for diabetic retinopathy and/or diabetic macular edema could not be reliably performed.\nA consultation with an eye specialist is recommended.`;
    }
    
    // Format date
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[nextStepDate.getMonth()];
    const day = nextStepDate.getDate();
    const year = nextStepDate.getFullYear();
    const formattedDate = `${month} ${day} ${year}`;
    return { date: formattedDate, message };
  }

  // Get DME status for both eyes
  const leftHasDME = hasDME(leftDME);
  const rightHasDME = hasDME(rightDME);
  
  // Create diagnosis keys for both eyes
  const leftDiagnosis = createDiagnosisKey(left, leftHasDME);
  const rightDiagnosis = createDiagnosisKey(right, rightHasDME);

  // Determine highest priority diagnosis
  const priorities = Object.keys(DR_PRIORITY);
  let mostSevere = null;

  for (let diagnosis of priorities) {
      if (leftDiagnosis === diagnosis || rightDiagnosis === diagnosis) {
          mostSevere = diagnosis;
          break;
      }
  }

  if (mostSevere) {
      const priority = DR_PRIORITY[mostSevere];
      if (priority.days) {
          nextStepDate.setDate(currentDate.getDate() + priority.days);
      } else if (priority.months) {
          nextStepDate.setMonth(currentDate.getMonth() + priority.months);
      }
      message = priority.message;
  } else {
      message = "No valid DR grade provided.";
  }

  // Format as "Nov 19 2025" (Month Date Year)
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[nextStepDate.getMonth()];
  const day = nextStepDate.getDate();
  const year = nextStepDate.getFullYear();
  const formattedDate = `${month} ${day} ${year}`;

  return { date: formattedDate, message };
}


/** DR severity -> badge style, shared by patientRecordsReport.js (list badge) and pdfTemplate.js (PDF text color). */
export const DR_GRADE_STYLES = {
    "No Diabetic Retinopathy": { backgroundColor: "#F2FFEB", color: "#31BC00", border: "1px solid #31BC008F" },
    "Mild Diabetic Retinopathy": { backgroundColor: "#FFFCEB", color: "#9F9431", border: "1px solid #D5A7028F" },
    "Moderate Diabetic Retinopathy": { backgroundColor: "#FFF9E9", color: "#ED7E17", border: "1px solid #ED7E178F" },
    "Severe Diabetic Retinopathy": { backgroundColor: "#FFFCF5", color: "#D06203", border: "1px solid #D0620347" },
    "Proliferative Diabetic Retinopathy": { backgroundColor: "#FFF8F8", color: "#CC0505", border: "1px solid #CC05054D" },
};
export const DEFAULT_DR_GRADE_STYLE = { backgroundColor: "#F2FFEB", color: "#31BC00", border: "1px solid #31BC008F" };

/** DME present/absent colors — same red/green as .dmeTextPresent/.dmeTextAbsent (inferenceDetailsComponent.css)
 *  and .dmeBadgeRed/.dmeBadgeGreen (patientRecordsReport/styles.css). */
export const DME_COLORS = { present: "#CC0505", absent: "#31BC00" };

// Helper function to convert DR_grade to display format
export const convertDRGradeToDisplay = (drGrade) => {
    if (!drGrade) return undefined;
    
    const gradeMap = {
        "No DR": "No Diabetic Retinopathy",
        "Mild NPDR": "Mild Diabetic Retinopathy",
        "Moderate NPDR": "Moderate Diabetic Retinopathy",
        "Severe NPDR": "Severe Diabetic Retinopathy",
        "PDR": "Proliferative Diabetic Retinopathy"
    };
    
    return gradeMap[drGrade] || drGrade;
};

// Helper function to get inference from classification or model_outputs
export const getInferenceFromData = (classification, modelOutputs) => {
    if (classification?.predicted_class_name) {
        return classification.predicted_class_name;
    }
    if (modelOutputs?.drdme?.DR_grade) {
        return convertDRGradeToDisplay(modelOutputs.drdme.DR_grade);
    }
    return null;
};

export const handleSetDR = (classification, gradability, modelOutputs = null) => {
    // First check if classification exists
    if (classification && classification.predicted_class_name) {
        if (
            gradability?.predicted_class_name === "Non Gradable" &&
            classification === undefined
        ) {
            return "Non Gradable Image";
        } else {
            return classification.predicted_class_name;
        }
    }
    
    // If classification is empty, try to use DR_grade from model_outputs
    if (modelOutputs?.drdme?.DR_grade) {
        return convertDRGradeToDisplay(modelOutputs.drdme.DR_grade);
    }
    
    // Fallback to gradability check
    if (gradability?.predicted_class_name === "Non Gradable") {
        return "Non Gradable Image";
    }
    
    return undefined;
};

export function handleSetReferral (
    left, 
    right, 
    singleImageReason = null,
    operatorOverride = { left: { fundus: false, eye: false }, right: { fundus: false, eye: false } },
    dmeInfo = { left: null, right: null }
) {
  
    // Return null if data is not available (loading state)
    if (!left && !right && !singleImageReason) {
        return null;
    }
  
    // Normalize DR values for comparison
    const normalizeDR = (dr) => {
        if (!dr) return null;
        // Handle various formats
        if (dr === "No DR" || dr === "No Diabetic Retinopathy") {
            return "No Diabetic Retinopathy";
        }
        if (dr === "Mild NPDR" || dr === "Mild Diabetic Retinopathy") {
            return "Mild Diabetic Retinopathy";
        }
        return dr;
    };
    
    const normalizedLeft = normalizeDR(left);
    const normalizedRight = normalizeDR(right);
    
    // Check for DME - normalize DME values (case-insensitive, handle variations)
    const hasLeftDME = dmeInfo?.left === "DME" || dmeInfo?.left === "dme" || dmeInfo?.left === true;
    const hasRightDME = dmeInfo?.right === "DME" || dmeInfo?.right === "dme" || dmeInfo?.right === true;
    
    // Check for operator override - ONLY consider fundus override (not eye override)
    const hasLeftOverride = operatorOverride?.left?.fundus === true;
    const hasRightOverride = operatorOverride?.right?.fundus === true;
    
    // Handle single image cases based on reason
    if (singleImageReason) {
        if (singleImageReason === "Patient is monocular") {
            // For single eye patients, only check the available eye
            const availableEye = normalizedLeft || normalizedRight;
            const availableDME = normalizedLeft ? hasLeftDME : hasRightDME;
            const availableOverride = normalizedLeft ? hasLeftOverride : hasRightOverride;
            
            if (!availableEye) {
                return null; // Data not available
            }
            
            // If override or DME exists, referral required
            if (availableOverride || availableDME) {
                return "Required";
            }
            
            // Check DR status
            if (availableEye === "No Diabetic Retinopathy" || availableEye === "Mild Diabetic Retinopathy") {
                return "Not Required";
            } else {
                return "Required";
            }
        } else if (singleImageReason === "Unclear image due to the presence of other ophthalmic conditions") {
            // Unclear image always requires referral
            return "Required";
        }
    }
    
    // Handle dual image cases
    // If both are undefined/null, return null (loading state)
    if (!normalizedLeft && !normalizedRight) {
        return null;
    }
    
    // If BOTH eyes have "No Diabetic Retinopathy" AND no DME AND no override → Not Required
    if (
      (normalizedLeft === "No Diabetic Retinopathy" || normalizedLeft === "Mild Diabetic Retinopathy") &&
      (normalizedRight === "No Diabetic Retinopathy" || normalizedRight === "Mild Diabetic Retinopathy") &&
      !hasLeftDME &&
      !hasRightDME &&
      !hasLeftOverride &&
      !hasRightOverride
    ) {
      return "Not Required";
    }
    
    // If override exists in ANY eye → Required
    if (hasLeftOverride || hasRightOverride) {
        return "Required";
    }
    
    // If DME exists in ANY eye → Required
    if (hasLeftDME || hasRightDME) {
        return "Required";
    }
    
    // Otherwise, check DR status
    if (
      (normalizedLeft === "No Diabetic Retinopathy" || normalizedLeft === "Mild Diabetic Retinopathy") &&
      (normalizedRight === "No Diabetic Retinopathy" || normalizedRight === "Mild Diabetic Retinopathy")
    ) {
      return "Not Required";
    } else {
      return "Required";
    }
};

export const RequiredRefferal = (
    classification, 
    singleImageReason = null,
    operatorOverride = { fundus: false, eye: false },
    dmeGrade = null
) => {
  
  // Check for operator override - ONLY consider fundus override (not eye override)
  if (operatorOverride?.fundus === true) {
    return true;
  }
  
  // Check for DME - if DME is present, referral is REQUIRED
  if (dmeGrade === "DME") {
    return true;
  }
  
  // Handle single image cases
  if (singleImageReason) {
    if (singleImageReason === "Patient is monocular") {
      // For single eye patients, only check the classification
      if (classification === "No Diabetic Retinopathy" || classification === "Mild Diabetic Retinopathy") {
        return false;
      } else {
        return true;
      }
    } else if (singleImageReason === "Unclear image due to the presence of other ophthalmic conditions") {
      // Unclear image always requires referral
      return true;
    }
  }
  
  // Handle normal cases (original logic)
  if(classification === "No Diabetic Retinopathy" || classification  === "Mild Diabetic Retinopathy") {
    return false;
  } else {
    return true;
  }
};

/**
 * Extract follow-up date from text string
 * @param {string} followUpText - Text containing date information
 * @returns {string|null} - Extracted date in format "Oct 29 2025" or null if not found
 */
export const extractFollowUpDate = (followUpText) => {
    if (!followUpText) return null;
    
    try {
        // Look for date pattern like "Oct 29 2025" or "29 Oct 2025"
        const datePatterns = [
            /(\w{3})\s+(\d{1,2})\s+(\d{4})/i,  // "Oct 29 2025"
            /(\d{1,2})\s+(\w{3})\s+(\d{4})/i,  // "29 Oct 2025"
            /(\w{3,})\s+(\d{1,2}),?\s+(\d{4})/i,  // "October 29, 2025"
            /(\d{1,2})\s+(\w{3,})\s+(\d{4})/i   // "29 October 2025"
        ];
        
        for (const pattern of datePatterns) {
            const match = followUpText.match(pattern);
            if (match) {
                const [, part1, part2, year] = match;
                
                // Check if first part is month or day
                if (isNaN(part1)) {
                    // First part is month (e.g., "Oct")
                    const month = part1;
                    const day = part2;
                    return `${month} ${day} ${year}`;
                } else {
                    // First part is day (e.g., "29")
                    const day = part1;
                    const month = part2;
                    return `${month} ${day} ${year}`;
                }
            }
        }
        
        return null;
    } catch (error) {
        console.error('Error extracting follow-up date:', error);
        return null;
    }
};